import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import Loading from '../components/Loading';
import { Helmet } from 'react-helmet';

function Notifications() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(1); 
    const [loading, setLoading] = useState(true);
    const [followList, setFollowList] = useState([]);
    const [captainCategory, setCaptainCategory] = useState([]);

    const hostData = getItemFromLocalStorage('hostProfile');
    const token = hostData.host_access_token;
    const hostId = getItemFromLocalStorage('host_id');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            const formData = new FormData();
            formData.append('listing_id', hostId);
            formData.append('token', token);
            formData.append('type', 'host');
            formData.append('category', activeTab);
            formData.append('web', 1);

            const url = `${params.baseURL}${params.endpoints.notificationList}`;

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: url,
                    data: formData
                });
                if (response.data.items && Array.isArray(response.data.items)) {
                    setFollowList(response.data.items);
                } else {
                    console.log('Data not Found.');
                }
            } catch (error) {
                console.log(error.message);
            } finally {
                setLoading(false);
            }
        };

        const getCaptainCategory = async () => {
            const formData = new FormData();
            formData.append('token', token);
            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.notificationCategory}`,
                    data: formData
                });
                if (response.data.status === 'found') {
                    setCaptainCategory(response.data.notification_category);
                } else {
                    console.log('Data not Found.');
                }
            } catch (error) {
                console.log(error.message);
            }
        };

        fetchData();
        getCaptainCategory();
    }, [activeTab, hostId, token]);

    const handleNotificationClick = (data) => {
        const payload = data.message_payload;
        if (!payload?.module) return;

        switch (payload.module) {
            case 'HOSTNEWBOOKING':
                navigate(`/booking-details/${payload.id}/1`);
                break;
            case 'CANCELLATIONFORHOST':
                navigate(`/booking-details/${payload.id}/1`);
                break;
            case 'HOSTIDVERIFY':
                navigate(`/home/`);
                break;
            default:
                break;
        }
    };

    return (
        <div>
            <Helmet>
                <title>Notification</title>
            </Helmet>
            <div className="ntab-buttons d-flex">
                {captainCategory.map((list) => (
                    <button 
                        key={list.id}
                        onClick={() => handleTabClick(list.id)} 
                        className={activeTab === list.id ? 'tb-btn tb-active' : 'tb-btn'}
                    >
                        {list.title}
                    </button>
                ))}
            </div>
            <span className='side-line'></span>
            <div className="ntab-content">
                {loading ? (
                    <Loading />
                ) : (
                    <div className="tab-content-item">
                        <div className='notification-box'>
                            {followList.length > 0 ? (
                                <>
                                    {followList.map((data) => {
                                        const isClickable = ['HOSTNEWBOOKING', 'CANCELLATIONFORHOST', 'HOSTIDVERIFY'].includes(data.message_payload?.module);

                                        return (
                                            <div 
                                                className='notification-list'
                                                key={data.notification_id}
                                                onClick={() => isClickable && handleNotificationClick(data)}
                                                style={{ cursor: isClickable ? 'pointer' : 'default' }}
                                            >
                                                <div className='notification-list_content'>
                                                    <div className='notification-first_box'>
                                                        <div className='notification-list_img'>
                                                            <img 
                                                                src={data.sender_info?.image ? data.sender_info.image : '/assets/img/icons/default_user.svg'}
                                                                alt="Wire Stay User" 
                                                                className='noti-pic ffl-sender-img'
                                                            />
                                                            <img 
                                                                src={data.sender_info?.image ? data.sender_info.image : '/assets/img/icons/default_user.svg'}
                                                                alt="Wire Stay User" 
                                                                className='noti-pic ffl-guest-img'
                                                            />
                                                        </div>
                                                        <div className='notification-list_detail'>
                                                            <p className='noti-title'>{data.message_title}</p>
                                                            <p className='noti-time'>{data.created_time_as_text}</p>
                                                        </div>
                                                    </div>
                                                    <hr style={{margin:'0',opacity:'1',borderTop:'2px solid #a6a6a6'}}></hr>
                                                    <div className='notification-second_box'>
                                                        <p className='noti-desc'>{data.message}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            ) : (
                                <div className='empty-section text-center'>
                                    {activeTab === 1 && (
                                        <img src={'/assets/img/placeholder/booking_noti.svg'} className='empty-image img-fluid' alt='' />
                                    )}
                                    {activeTab === 2 && (
                                        <img src={'/assets/img/placeholder/cancellation_noti.svg'} className='empty-image img-fluid' alt='' />
                                    )}
                                    {activeTab === 4 && (
                                        <img src={'/assets/img/placeholder/general_noti.svg'} className='empty-image img-fluid' alt='' />
                                    )}
                                    {/*<img src={'/assets/img/icons/no-notification.png'} alt='Wire Stay' />*/}
                                </div>
                            )}
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
}

export default Notifications;
